import { Breadcrumbs, Grid, Link, Typography } from '@mui/material'
import { PADDING_BASE } from '../../assets/Styles'
import TitlebarAction from '../../components/common/TitlebarActions'
import TopSideBar from '../../components/TopSideBar'
import SiteCreate from '../../components/SiteCreate'
import PageContainer from '../../components/common/PageContainer'

export default function SiteCreatePage({ setBlockScreen }: any) {
  return (<>
    <TopSideBar currentSection='sites' disableProjectSelector />

    <PageContainer>

      <Grid paddingBottom={PADDING_BASE}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="darkgreen" href="/tickets/listing">
            Home
          </Link>
          <Link underline="hover" color="darkgreen" href="/sites/listing">
            Sitios
          </Link>
          <Typography color="darkgreen" fontWeight="bold">
            Nuevo
          </Typography>
        </Breadcrumbs>
      </Grid>

      <TitlebarAction title='Nuevo Sitio' />

      <SiteCreate
        setBlockScreen={setBlockScreen}
      />
    </PageContainer>
  </>)
}